import get from '@invitato/helpers/dist/getLocale';

export default {
  open: get('BUKA UNDANGAN', 'OPEN INVITATION'),
  openAnnouncement: get('BUKA PEMBERITAHUAN', 'OPEN ANNOUNCEMENT'),
};